import type { MetaAdsFormScope, MetaLeadForm } from "./types"

export type MetaLeadFormDeliveryMode = "all_submissions" | "targeted_ads_only" | "unknown"

export type MetaLeadFormReadiness = {
  deliveryMode: MetaLeadFormDeliveryMode
  phoneFieldKeys: string[]
  configuredPhoneFieldPresent: boolean
}

const PHONE_QUESTION_TYPES = new Set(["PHONE", "PHONE_NUMBER"])

export function getMetaLeadFormReadiness(
  form: MetaLeadForm,
  phoneFieldKey: string,
): MetaLeadFormReadiness {
  const questionKeys = new Set(
    form.questions.flatMap(question => question.key ? [question.key] : []),
  )
  return {
    deliveryMode: getDeliveryMode(form),
    phoneFieldKeys: getPhoneFieldKeys(form),
    configuredPhoneFieldPresent: questionKeys.has(phoneFieldKey),
  }
}

export function getFormsInScope(
  forms: MetaLeadForm[],
  formScope: MetaAdsFormScope,
  selectedFormIds: string[],
): MetaLeadForm[] {
  if (formScope === "all") return forms
  const selectedIds = new Set(selectedFormIds)
  return forms.filter(form => selectedIds.has(form.id))
}

export function getCommonPhoneFieldKeys(forms: MetaLeadForm[]): string[] {
  if (forms.length === 0) return []
  const commonKeys = new Set(getPhoneFieldKeys(forms[0]))
  for (const form of forms.slice(1)) {
    const formKeys = new Set(getPhoneFieldKeys(form))
    for (const key of commonKeys) {
      if (!formKeys.has(key)) commonKeys.delete(key)
    }
  }
  return [...commonKeys].sort()
}

function getDeliveryMode(form: MetaLeadForm): MetaLeadFormDeliveryMode {
  if (
    form.allow_organic_lead === false
    || form.block_display_for_non_targeted_viewer === true
  ) {
    return "targeted_ads_only"
  }
  if (
    form.allow_organic_lead === true
    && form.block_display_for_non_targeted_viewer === false
  ) {
    return "all_submissions"
  }
  return "unknown"
}

function getPhoneFieldKeys(form: MetaLeadForm): string[] {
  const keys = new Set<string>()
  for (const question of form.questions) {
    if (!question.key) continue
    if (PHONE_QUESTION_TYPES.has(question.type.toUpperCase()) || question.key === "phone_number") {
      keys.add(question.key)
    }
  }
  return [...keys].sort()
}
